<template>
  <div class="bg-white hpercent100 fs-14">
    <div
      class="height-175 font-bold boxshadow-bottom bg-008c8c fc-white relative"
    >
      <div class="logout" @click="logoutUser">
        <p><u>退出登录>></u></p>
        <!-- <img class="inline-block w14-h14 logouIcon" :src="logout" alt="退出登录"> -->
      </div>
      <div class="pl-15 wpercent80">
        <div class="pt-35 fs-20">客户：{{ nowProject.customerName }}</div>
        <div class="pt-35 fs-20">项目：{{ nowProject.projectName }}</div>
      </div>
      <img
        :src="switchIcon"
        class="inline-block w27-h28 switchIcon"
        @click="switchProject"
      />
    </div>
    <!-- 菜单列表 -->
    <!-- 通知noTice -->
    <div>
      <notice-bar :msgText="msgText" click v-if="msgText" />
    </div>
    <!-- 如果要flex布局 就加 flex 在根节点  庵后加margin-auto 到 循环节点 -->
    <div class="flex flex-space-around flex-wrap p20" v-if="!isTarget">
      <div
        class="wperenct30 text-align-center margin-auto"
        v-for="(item, index) in homeItemMenu"
        :key="index"
      >
        <div @click="jumpPage(item)">
          <img :src="`${item.icon}`" class="inline-block w27-h28" />
          <p class="fc-333">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSessionStorage } from "@/utils/utils";
import IncomeIcon from "./../../assets/Income_icon.png"; // 佣金icon
import switchIcon from "./../../assets/switch_icon.png"; // 切换项目icon
import welfareIcon from "./../../assets/welfare_icon.png"; // 福利icon
import logout from "./../../assets/logout.png"; // 切换项目icon
import { UserModule } from "@/store/store_modular/user";
import noticeBar from "@/components/basic/noTice";
import { temporaryNews } from "@/views/home/temporaryNews";
import { temporaryLink } from '@/views/home/temporaryLink';
import { Toast } from "vant";
export default {
  components: {
    noticeBar,
  },
  props: {
    isTarget:{ type: Boolean, required: false, default: false },
  },

  created() {
    const info = JSON.parse(getSessionStorage("nowProject"));
    const eminfo = JSON.parse(getSessionStorage("employeeInfo"));
    this.nowProject.customerId = info.customerId;
    this.nowProject.customerName = info.customerName;
    this.nowProject.projectId = info.projectId;
    this.nowProject.projectName = info.projectName;
    this.emInfo = eminfo;
    this.showMsg(this.temporaryNews, info.projectId, this.isTarget);
  },
  data() {
    return {
      // 雇员对象
      emInfo: {},
      // 切换项目的icon
      switchIcon: switchIcon,
      // 退出登录的icon
      logout: logout,
      // 菜单列表 对象，主要是集合了所有的元素对象
      homeItemMenu: [
        {
          title: "佣金查询",
          type: "route",
          router: "/home/IncomeDetai",
          index: 0,
          icon: IncomeIcon, // icon
        },
        {
          title: "内介专属通道",
          type: "route",
          router: "/home/welfare",
          index: 1,
          icon: welfareIcon, // icon
        },
      ],
      // 通知消息
      msgText:
        "",
      // 当前项目
      nowProject: {
        customerName: "",
        customerId: -1,
        projectName: "",
        projectId: -1,
      },
      // 手动写死一个消息体，用来临时展示对应项目的通知。
      temporaryNews: temporaryNews,
      temporaryLink: temporaryLink,
    };
  },
  methods: {
    // 跳转菜单
    jumpPage(item) {
      if (item.type === "route") {
        if (item.index === 1) {
          if(this.emInfo.workState === 11) {
            Toast("你已离职，不可使用该功能！");
            return;
          }
          this.toMenuLink(this.temporaryLink, JSON.parse(getSessionStorage("nowProject")).projectId);
          return;
        }
        const r = Math.random(); // 触发 组件 更新
        this.$router.push({
          path: `${item.router}`,
          query: { r },
        });
      } else {
        console.warn("没有这个选项");
      }
    },
    // 切换项目页面
    switchProject() {
      const r = Math.random(); // 触发 组件 更新
      this.$router.push({
        path: "/home/selectProject",
        query: { r },
      });
    },
    // 退出登录
    logoutUser() {
      UserModule.LogOut(); // 退出登录
      Toast("退出成功");
    },
    // 展示消息的方法
    showMsg(obj, projectId, isTarget){
      for(let i = 0; i < obj.length; i++) {
        if(obj[i].projectId === projectId) {
            this.msgText = isTarget ? obj[i].insideMsg : obj[i].outsideMsg;
        }
      }
    },
    // 根据项目id进入不同的链接
    toMenuLink(obj, projectId) {
      for(let i = 0; i < obj.length; i++) {
        if(obj[i].projectId === projectId) {
          window.open(`${obj[i].link}`, '_self');
        } else {
          Toast("即将开放，敬请期待");
        }
      }
    }
// -----------------------------------------------------------------------------------------------------分割线------------------------------------
  },
};
</script>

<style lang="less">
.switchIcon {
  position: absolute;
  right: 5%;
  top: 35%;
}
.boxshadow-bottom {
  box-shadow: 0px 0px 8px 1px #b4bbc5;
}
.logout {
  position: absolute;
  height: 20px;
  line-height: 20px;
  float: right;
  top: 5%;
  right: 5%;
  .logouIcon {
    position: absolute;
    right: 5%;
    top: 35%;
  }
}
</style>
